import React, { useState } from 'react';
import { SvgIcon, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import ShieldCheckmarkIcon from '../../../icons/shield-checkmark.svg?react';
import ButtonCardWithFunction from '../../Helpers/Buttons/ButtonCardWithFunction';
import NeedsCalculator from './NeedsCalculator';
import { SESSION_STORAGE_NEEDS_ANALYSIS_KEY } from '../../../sessionStorage';
import './NeedsAnalysisButton.scss'

export default function NeedsAnalysisButton(props) {
  const navigate = useNavigate();
  const shape = props.shape ? props.shape : 'wide';

  const title = props.title || "NEEDS ANALYSIS";
  const icon = props.icon || <SvgIcon component={ShieldCheckmarkIcon} />;

  const [modalNeedsCalculatorIsOpen, setModalNeedsCalculatorIsOpen] = useState(false);

  const setCoverageAmount = (face) => {
    if (props.setCoverageAmount != null) {
      props.setCoverageAmount(face)
    }
    else {
      sessionStorage.setItem(SESSION_STORAGE_NEEDS_ANALYSIS_KEY, face);
      navigate("/landing/term-insurance");
    }
  };

  const modalNeedsCalculatorFields = {
    modalNeedsCalculatorIsOpen: modalNeedsCalculatorIsOpen,
    setModalNeedsCalculatorIsOpen: setModalNeedsCalculatorIsOpen,
    setCoverageAmount: setCoverageAmount,
    minCoverageAmount: props.minCoverageAmount || 250000,
    maxCoverageAmount: props.maxCoverageAmount || 10000000,
  };

  const redirectToPolicyReview = () => {
    if (props.enablePolicyReview) {
      navigate('/policy-review');
      window.scroll(0, 0);
    }
    else {
      setModalNeedsCalculatorIsOpen(true);
    }
  };

  return (
    <div className="needs-analysis-button">
      <React.Fragment>
        {props.type === "quote-screen" ?
          <Button type="submit"
            onClick={() => setModalNeedsCalculatorIsOpen(true)}
            variant={props.isPrequote ? undefined : "contained"}
            color="primary"
            className={`${props.isPrequote ? "white-primary-button" : `quote-needs-button white-primary-button`}`}
          >
            {props.isPrequote ? <SvgIcon component={ShieldCheckmarkIcon} color="primary" /> : <div className={`icon-container mb-0 background-color-16`}><SvgIcon component={ShieldCheckmarkIcon} color="primary" /></div>}
            <span className="name">&nbsp;{title}</span>
          </Button>
          :
          <ButtonCardWithFunction id={0}
            name={title}
            onClick={redirectToPolicyReview}
            shape={shape}
            icon={icon}
            className="white-primary-button"
            isFromHomePage={props.isFromHomePage}
          />
        }
        <NeedsCalculator fields={modalNeedsCalculatorFields} isPrequote={props.isPrequote} isCustomTerm={props.isCustomTerm}/>
      </React.Fragment>
    </div>
  );
}

NeedsAnalysisButton.propTypes = {
  minCoverageAmount: PropTypes.number,
  maxCoverageAmount: PropTypes.number,
  shape: PropTypes.string,
};
